import { ISearchResponse } from '@sales-center/common'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ApiError, IEmployee } from '.'
import { ServiceConfig } from '../services/config'
import { get } from '../services/crud'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.coreProduct.employee}`
const summaryUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.coreProduct.employeeSummary}`

export const getEmployeeList = createAsyncThunk<
  IEmployee[],
  boolean | undefined,
  { rejectValue: ApiError }
>('employee', async (includeInactive, thunkApi) => {
  const response = await get(
    `${summaryUrl}${includeInactive ? '?includeInactive=true' : ''}`,
  )
  if (response.ok) {
    const payload: ISearchResponse<IEmployee> = await response.json()
    return payload.items
  }
  return thunkApi.rejectWithValue((await response.json()) as ApiError)
})

export const getEmployee = createAsyncThunk<IEmployee, string>(
  'employee/getSingle',
  async (employeeId, thunkApi) => {
    const response = await get(`${baseUrl}/${employeeId}`)

    if (response.ok) {
      const payload: IEmployee = await response.json()
      return payload
    }
    return thunkApi.rejectWithValue(await response.json())
  },
)
